import { CircleHelp } from 'lucide-react';
import React from 'react';
import { SupportAction } from 'hooks/useSupportActions';
import { buttonVariants } from 'components/ui/button';
import { cn } from 'lib/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown';

interface ISupportDropdownProps {
  supportActions: SupportAction[];
}

const SupportDropdown: React.FC<ISupportDropdownProps> = ({ supportActions }) => {
  return (
    <div className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }), 'cursor-pointer')}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <CircleHelp data-testid="support-dropdown-menu-icon" size={26} />
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="border-solid border-card-border"
          data-cy="support-dropdown-menu"
        >
          {supportActions.map((action) => (
            <DropdownMenuItem key={action.title} onClick={action.action} className="cursor-pointer">
              {action.icon && <span className="mr-2">{action.icon}</span>}
              {action.title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default SupportDropdown;
